export default "__VITE_ASSET__13739944__"